<template>
    <div class="test-result" v-if="result !== null">
        <el-tag :type="result ? 'success' : 'danger'" size="large">
            {{ result ? '连接成功' : '连接失败' }}
        </el-tag>
        <span class="result-message" v-if="message">{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: 'TestResult',
    props: {
        result: {
            type: Boolean,
            default: null
        },
        message: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.test-result {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.result-message {
    color: #64748b;
    font-size: 13px;
}
</style>